import React, { useState, useEffect, Fragment } from 'react';
import { Select, Popup, Form_boxed_section } from '../../../../../components';
import AddIcon from '@material-ui/icons/Add';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { connect } from 'react-redux';





function Generate_chart_popup(props) {
    
    const [type, setType] = useState('all');
    const [sub_type, setSubType] = useState();
    const [category, setCategory] = useState();
    const [team_member, setTeamMember] = useState('all');
    const [chart_type, setChartType] = useState('line');
    const [segment, setSegment]=useState('none');
    const [dimension_1, setDimension1]=useState();
    const [dimension_2, setDimension2]=useState();


    useEffect(() => {
        if(props.dashboard!=undefined && props.id!=undefined){
            for(let ag of props.dashboard.analytics_graphs){
                if(ag.id==props.id){
                setType(ag.type);
                setSubType(ag.sub_type);
                setCategory(ag.category);
                setSegment(ag.segment);
                setTeamMember(ag.team_member);
                setChartType(ag.chart_type);
                setDimension1(ag.dimension_1);
                setDimension2(ag.dimension_2);
            }}
        }
     }, []);
    let owners = [{ id: 'all', name: 'Compare' }, { id: 'all_users', name: 'Total' }];
    for (let k in props.workspace_data.user_workspaces) {
        if (props.workspace_data.user_workspaces[k].superuser != true && props.workspace_data.user_workspaces[k].superuser != 1) {
            if (props.workspace.admin != true && props.me.id == props.workspace_data.user_workspaces[k].user_id && team_member != props.workspace_data.user_workspaces[k].id) {
                setTeamMember(props.workspace_data.user_workspaces[k].id);
            }; owners.push({ id: props.workspace_data.user_workspaces[k].id, name: props.workspace_data.user_workspaces[k].first_name + ' ' + props.workspace_data.user_workspaces[k].last_name });
        }
    }


    console.log('QUEUES', props.queues, props);
    //<Grid item xs={12}><TextField title='Name' value={name} onChange={(e)=>{setName(e.target.value)}}/></Grid>

    let sub_type_options=[{id:'all', name:'All'}];

    let category_type_data = [{ id: 'all', name: 'All' }];
    let type_data=undefined; 
    if (type != 'all') {type_data = props.timeline_item_sub_types[type];}
    let sub_type_data=undefined; 
    if(type_data!=undefined){
        for(let key in type_data){
            if(key!='default'){category_type_data.push({id:key, name:(props.category_dictionary[key]==undefined)?key:props.category_dictionary[key]});}
        }
        sub_type_data=type_data[(category=='default')?type_data.default:category];
    }

    for (let key in sub_type_data) { sub_type_options.push({ id: key, name: (sub_type_data[key].title == undefined) ? sub_type_data[key]: sub_type_data[key].title});}   
    
    
    let segment_data=[{id:'none', name:'No segment'}];
    for(let cd of category_type_data){
        if((cd.id!=category || sub_type=='all' || sub_type==undefined) && cd.id!='all'){
            segment_data.push(cd);
        }
    }

    if(segment==undefined || (segment==category && sub_type!='all' && sub_type!=undefined)){setSegment((segment_data.length>1)?segment_data[1].id:'none');}
    //{ (props.workspace != undefined && props.workspace.admin == true) ? <Grid item xs={6} style={{ marginBottom: '20px' }}><Select no_field size='small' variant='outlined' title='Team member' name='user_workspace_id' value={team_member} onChange={(e) => { setTeamMember(e.target.value) }} style={{ width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '10px', backgroundColor: '#f7f9fc' }} select_data={owners} /></Grid> : null }


    let d_1_data=[{id:'default', name:'Default time frame'}, {id:'time', name:'Time'}, {id:'week_day', name:'Day of week'}, {id:'user_workspace_id', name:'User'}];
    let d_2_data=[{id:'time', name:'Time'}, {id:'week_day', name:'Day of week'}, {id:'user_workspace_id', name:'User'}];
    let dimension_1_data=[]; let dimension_2_data=[];
    for(let x of d_1_data){if(x.id!=segment && x.id!=dimension_2){ dimension_1_data.push(x);}else if(x.id==dimension_1){setDimension1('default');}}
    for (let x of d_2_data) {if (x.id != segment && x.id != dimension_1) { dimension_2_data.push(x);}else if(x.id==dimension_2){setDimension2(undefined);}}
    for(let s of segment_data){
        if(s.id!='none' && s.id!=segment && s.id!=dimension_2){dimension_1_data.push(s);}else if(s.id==dimension_1){setDimension1('default');}
        if(s.id!='none' && s.id!=segment && s.id!=dimension_1){dimension_2_data.push(s);}else if(s.id==dimension_2) {setDimension2(undefined);}
    }

    return (
        <Popup always_open title={(props.id == undefined) ? 'New chart' : 'Update chart'} accept_button_click={() => { 
            

            props.createUpdateChart({ 
                id: props.id, 
                analytics_dashboard_id: props.analytics_dashboard_id, 
                user_workspace_id: team_member, 
                type:type,
                category:category,
                sub_type:(sub_type=='all')?undefined:sub_type,
                subject: '',
                segment:(type=='all')?'timeline_item_type':(segment=='none')?undefined:segment,
                chart_type: chart_type,
                dimension_1:(dimension_1=='default')?undefined:dimension_1,
                dimension_2:dimension_2 
            }); 
            
            
            props.handleClose(); }} handleClose={props.handleClose} content={
            <div style={{ width: '600px' }}>
             <Grid container style={{ marginTop: '20px', marginBottom: '20px', width: ' calc(100% - 40px)', marginLeft: '20px' }}>
                
                    <Grid item xs={12}>
                        <Form_boxed_section title={<Typography>Select the subject of the chart</Typography>} content={
                        <Grid container>
                            <Grid item xs={6} sm={4} style={{ marginBottom: '20px' }}><Select no_field size='small' variant='outlined' title='Subject' name='type' value={type} onChange={(e) => { setSegment(undefined); setType(e.target.value); setSubType(undefined); setCategory('all'); if (e.target.value == 'tasks_overdue') { setChartType('line'); } }} style={{ width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '10px', backgroundColor: '#f7f9fc' }} select_data={[{ id: 'all', name: 'All' }, { id: 'phone_calls', name: 'Phone calls' }, { id: 'emails', name: 'Emails' }, { id: 'messages', name: 'Messages' }, { id: 'meetings', name: 'Meetings' }, { id: 'tasks_overdue', name: 'Tasks overdue' }, { id: 'tasks_completed', name: 'Tasks completed' }]} /></Grid>
                            {(category_type_data.length <= 1) ? null : <Grid item xs={6} sm={4} style={{ marginBottom: '20px' }}><Select no_field size='small' variant='outlined' title='Filter on' value={category} onChange={(e) => { setCategory(e.target.value); setSubType(undefined);}} name='category' style={{ width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '10px', backgroundColor: '#f7f9fc' }} select_data={category_type_data} /></Grid>}
                            {(type == 'all' || category==undefined || category=='all') ? null : <Grid item xs={6} sm={4} style={{ marginBottom: '20px' }}><Select no_field size='small' variant='outlined' title={(props.category_dictionary[category] == undefined) ? category : props.category_dictionary[category]} value={sub_type} onChange={(e) => { setSubType(e.target.value) }} name='sub_type' style={{ width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '10px', backgroundColor: '#f7f9fc' }} select_data={sub_type_options} /></Grid>}
                        </Grid>
                    } />
                    </Grid>
                        <Grid item xs={6} style={{ marginTop: '10px', marginBottom: '10px' }}><Select no_field size='small' varian='outlined' title='Chart type' name='chart_type' value={chart_type} onChange={(e) => { setChartType(e.target.value); setDimension1(undefined); setDimension2(undefined); }} style={{ width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '10px', backgroundColor: '#f7f9fc' }} select_data={(type == 'tasks_overdue') ? [{ id: 'bar', name: 'Bar' }, { id: 'line', name: 'Line' }, { id: 'bar_stacked', name: 'Stacked bar (with moving average)' }] : [{ id: 'bar', name: 'Bar' }, { id: 'line', name: 'Line' }, { id: 'bar_stacked', name: 'Stacked bar (with moving average)' }, { id: 'pie', name: 'Pie' }, { id: 'horizontal_bar', name: 'Horizontal bar' }, {id:'bubble', name:'Bubble'}]} /></Grid>
                    {(segment_data.length<=1)?null:<Grid item xs={6} style={{marginTop:'10px', marginBottom:'10px'}}><Select no_field size='small' variant='outlined' title='Segment by' name='segment' value={segment} onChange={(e) => { setSegment(e.target.value); }} style={{ width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '10px', backgroundColor: '#f7f9fc' }} select_data={segment_data} /></Grid>}
                    {(chart_type=='horizontal_bar' || chart_type=='bubble')?<Grid item xs={6} style={{marginTop:'10px', marginBottom: '10px' }}><Select no_field size='small' varian='outlined' title={(chart_type == 'horizontal_bar') ? 'Y axis' : 'X axis'} name='dimension_1' value={dimension_1} onChange={(e) => { setDimension1(e.target.value); }} style={{ width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '10px', backgroundColor: '#f7f9fc' }} select_data={dimension_1_data} /></Grid>:null}
                    {(chart_type=='bubble')?<Grid item xs={6} style={{marginTop:'10px', marginBottom: '10px' }}><Select no_field size='small' varian='outlined' title='Y axis' name='dimension_2' value={dimension_2} onChange={(e) => { setDimension2(e.target.value) }} style={{ width: 'calc(100% - 20px)', marginLeft: '10px', marginTop: '10px', backgroundColor: '#f7f9fc' }} select_data={dimension_2_data} /></Grid>:null}
            </Grid>
            </div>} button_variant='icon_button' button={<AddIcon />} accept_button='Generate' />
    )
}


export default connect(ss, dd)(Generate_chart_popup);


function ss(state) {
    return {
        refresh: state.analytics.refresh,
        timeline_item_data: state.analytics.data,
        queues: state.lists.queue_data,
        analytics_settings: state.analytics.settings
    }
}

function dd(dispatch) {
    return {
        getTimelineItemsData: (user_workspace_id, start_date, end_date, type, sub_type) => { dispatch({ type: 'REQUEST_INDEX_TIMELINE_ITEMS', user_workspace_id: user_workspace_id, start_date: start_date, end_date: end_date, d_type: type, sub_type: sub_type }); },
        index_queues: () => { dispatch({ type: 'REQUEST_QUEUE_INDEX' }) },
        createUpdateChart: (val) => { dispatch({ type: 'REQUEST_CREATE_UPDATE_ANALYTICS_CHART', val: val }) }
    }
}
